import { render, staticRenderFns } from "./CancellationDetailView.vue?vue&type=template&id=8d5b675c&"
import script from "./CancellationDetailView.vue?vue&type=script&lang=js&"
export * from "./CancellationDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d5b675c')) {
      api.createRecord('8d5b675c', component.options)
    } else {
      api.reload('8d5b675c', component.options)
    }
    module.hot.accept("./CancellationDetailView.vue?vue&type=template&id=8d5b675c&", function () {
      api.rerender('8d5b675c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cancellations/CancellationDetailView.vue"
export default component.exports